import { FC } from 'react';

import Image from './image.png';

export const BitcoinImage: FC = () => <img src={Image} alt="collections" />;
